// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__rQccJ","close":"Notification_close__P09jT","description":"Notification_description__ydoqp"};